import React, { Component } from 'react';
import './App.css';
import Logo from './bear-logo.svg';
import * as FontIcon from 'react-icons/lib/md';
import Modal from 'react-modal';
require('codemirror/lib/codemirror.css'); // codemirror
require('tui-editor/dist/tui-editor.css'); // editor ui
require('tui-editor/dist/tui-editor-contents.css'); // editor content
require('highlight.js/styles/github.css'); // code block highlight

var Editor = require('tui-editor');

Modal.setAppElement('#root')

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

function post(path, params, method) {
	method = method || "post"; // Set method to post by default if not specified.

	// The rest of this code assumes you are not using a library.
	// It can be made less wordy if you use one.
	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);
	form.setAttribute("target", "_blank");

	for(var key in params) {
		if(params.hasOwnProperty(key)) {
			var hiddenField = document.createElement("input");
			hiddenField.setAttribute("type", "hidden");
			hiddenField.setAttribute("name", key);
			hiddenField.setAttribute("value", params[key]);

			form.appendChild(hiddenField);
		 }
	}

	document.body.appendChild(form);
	form.submit();
}

function makepdf( content ){
	post('http://pdf2.ftqq.com/pdf',{'content':content,'pdfkey':'ftqqsocool'});
}

class App extends Component {


  constructor(props) {
    super(props);
    const first = parseInt(window.localStorage.getItem('guideclosed')) == 1 ? false : true;
    this.state = { 'mdtext': '', modalIsOpen: false , firstRun:first };
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }
  
  closeGuide() {
    this.setState({firstRun: false});
    window.localStorage.setItem('guideclosed',1);
  }

  componentDidMount()
  {
    // window.$ = $;
    window.mdeditor = new Editor({
      el: document.getElementById('MdEditor'),
      initialEditType: 'markdown',
      previewStyle: 'vertical',
      height: '100%',
      language:'zh_CN',
      exts:['scrollFollow','colorSyntax'],
      events:{'change':(e)=>{this.resumeChange(e)}},
      usageStatistics: false
    });

    if( window.localStorage.getItem('mdtext') !== null  )
    {
      window.mdeditor.setValue(  window.localStorage.getItem('mdtext') );
    }
   

    
  }

  resumeChange( e )
  {
    // console.log(e);
    this.setState( {'mdtext':window.mdeditor.getValue()} );
    window.localStorage.setItem('mdtext',window.mdeditor.getValue());
  }


  appendContact( e )
  {
    const contact = `
# 联系方式

（HR会打印你的简历，用于在面试的时候联系，所以联系方式放到最上边会比较方便）

- 手机：135.... （如果是外地手机，可注明。如经常关机，要写上最优联系时间）
- Email：goodman@gmail.com （虽然我觉得QQ邮箱无所谓，不过有些技术人员比较反感，建议用G，非要用的话，不要用数字邮箱名）
- QQ/微信号：6...（提供一个通过网络可以联系到你的方式）

`;
window.mdeditor.setValue(window.mdeditor.getValue()+contact);
this.resumeChange();
  } 

appendProfile( e )
{
  const profile = `
# 个人信息

 - 冷熊/男/1990 
 - 本科/北极大学计算机系 
 - 工作年限：3年
 - 微博：[@Easy](http://weibo.com/easy) （如果没有技术相关内容，也可以不放）
 - 技术博客：http://old.ftqq.com ( 使用GitHub Host的Big较高  )
 - Github：http://github.com/easychen ( 有原创repo的Github帐号会极大的提升你的个人品牌  )

 - 期望职位：PHP高级程序员，应用架构师
 - 期望薪资：税前月薪15k~20k，特别喜欢的公司可例外
 - 期望城市：北京

`;
    window.mdeditor.setValue(window.mdeditor.getValue()+profile);
    this.resumeChange();
  }

  appendExp( e )
  {
    const exp = `
# 工作经历
（工作经历按逆序排列，最新的在最前边，按公司做一级分组，公司内按二级分组）

## ABC公司 （ 2012年9月 ~ 2014年9月 ）

### DEF项目 
我在此项目负责了哪些工作，分别在哪些地方做得出色/和别人不一样/成长快，这个项目中，我最困难的问题是什么，我采取了什么措施，最后结果如何。这个项目中，我最自豪的技术细节是什么，为什么，实施前和实施后的数据对比如何，同事和领导对此的反应如何。


### GHI项目 
我在此项目负责了哪些工作，分别在哪些地方做得出色/和别人不一样/成长快，这个项目中，我最困难的问题是什么，我采取了什么措施，最后结果如何。这个项目中，我最自豪的技术细节是什么，为什么，实施前和实施后的数据对比如何，同事和领导对此的反应如何。


### 其他项目

（每个公司写2~3个核心项目就好了，如果你有非常大量的项目，那么按分类进行合并，每一类选一个典型写出来。其他的一笔带过即可。）

  
## JKL公司 （ 2010年3月 ~ 2012年8月 ）

### MNO项目 
我在此项目负责了哪些工作，分别在哪些地方做得出色/和别人不一样/成长快，这个项目中，我最困难的问题是什么，我采取了什么措施，最后结果如何。这个项目中，我最自豪的技术细节是什么，为什么，实施前和实施后的数据对比如何，同事和领导对此的反应如何。


### PQR项目 
我在此项目负责了哪些工作，分别在哪些地方做得出色/和别人不一样/成长快，这个项目中，我最困难的问题是什么，我采取了什么措施，最后结果如何。这个项目中，我最自豪的技术细节是什么，为什么，实施前和实施后的数据对比如何，同事和领导对此的反应如何。


### 其他项目

（每个公司写2~3个核心项目就好了，如果你有非常大量的项目，那么按分类进行合并，每一类选一个典型写出来。其他的一笔带过即可。）
  
  `;
      window.mdeditor.setValue(window.mdeditor.getValue()+exp);
      this.resumeChange();
    }

    appendMP( e )
    {
      const mp = `
# 开源项目和作品
（这一段用于放置工作以外的、可证明你的能力的材料）

## 开源项目
（对于程序员来讲，没有什么比Show me the code能有说服力了）

  - [STU](http://github.com/yourname/projectname)：项目的简要说明，Star和Fork数多的可以注明
  - [WXYZ](http://github.com/yourname/projectname)：项目的简要说明，Star和Fork数多的可以注明

## 技术文章
（挑选你写作或翻译的技术文章，好的文章可以从侧面证实你的表达和沟通能力，也帮助招聘方更了解你）

- [一个产品经理眼中的云计算：前生今世和未来](http://get.jobdeer.com/706.get)
- [来自HeroKu的HTTP API 设计指南(翻译文章)](http://get.jobdeer.com/343.get) （ 好的翻译文章可以侧证你对英文技术文档的阅读能力）

## 演讲和讲义
（放置你代表公司在一些技术会议上做过的演讲，以及你在公司分享时制作的讲义）

  - 2014架构师大会演讲：[如何通过Docker优化内部开发](http://ftqq.com)
  - 9月公司内部分享：[云计算的前生今世](http://ftqq.com)
    
    `;
    
      window.mdeditor.setValue(window.mdeditor.getValue()+mp);
      this.resumeChange();
    }
    
    appendSkills( e )
    {
      const string = `
# 技能清单
（我一般主张将技能清单写入到工作经历里边去。不过很难完整，所以有这么一段也不错）

以下均为我熟练使用的技能

- Web开发：PHP/Hack/Node
- Web框架：ThinkPHP/Yaf/Yii/Lavarel/LazyPHP
- 前端框架：Bootstrap/AngularJS/EmberJS/HTML5/Cocos2dJS/ionic
- 前端工具：Bower/Gulp/SaSS/LeSS/PhoneGap
- 数据库相关：MySQL/PgSQL/PDO/SQLite
- 版本管理、文档和自动化部署工具：Svn/Git/PHPDoc/Phing/Composer
- 单元测试：PHPUnit/SimpleTest/Qunit
- 云和开放平台：SAE/BAE/AWS/微博开放平台/微信应用开发
      `;
      window.mdeditor.setValue(window.mdeditor.getValue()+string); 
      this.resumeChange();
    }

    appendThanks( e )
    {
      const string = `
---      
# 致谢
感谢您花时间阅读我的简历，期待能有机会和您共事。
      `;
      window.mdeditor.setValue(window.mdeditor.getValue()+string); 
      this.resumeChange();
    }

    download( e )
    {
      download( '冷熊简历.MD' , window.mdeditor.getValue() );
    }

    makepdf( e )
    {
      
      //makepdf( window.mdeditor.getValue() );
      makepdf( document.querySelectorAll('.tui-editor-contents')[0].innerHTML );
    }

    
 

  render() {
    return (
      <div className="App">
        <div className="Container">
          <div className="SideBar">
            <div className="LogoBox">
              <img src={Logo} className="Logo" alt="logo"/>
              <div className="LogoText">冷熊简历</div>
            </div>
            <div className="SideMenu">
              <div className="Active"><a href="#">编辑</a></div>
              <div><a href="#" onClick={(e) => this.download(e)}>下载</a></div>
              <div><a href="#" onClick={(e) => this.makepdf(e)}>PDF</a></div>
              <div><a href="http://link.ftqq.com/KWkVX" target="_blank" rel="noopener noreferrer">教程</a></div>
              <div><a href="#" onClick={(e) => this.openModal(e)} >捐赠</a></div>
            </div> 
          </div>
          <div className="SectionBar">
            <div className="Editor Active">
            <FontIcon.MdTextFields/>Markdown
            </div>
            <div className="Spacer">内容片段</div>
            <ul className="GuideList">
              <li><a href="#" onClick={(e) => this.appendContact(e)}><FontIcon.MdMail/>联系方式</a></li>
              <li><a href="#" onClick={(e) => this.appendProfile(e)}><FontIcon.MdInsertEmoticon/>个人信息</a></li>
              <li><a href="#" onClick={(e) => this.appendExp(e)}><FontIcon.MdBusinessCenter/>经历证明</a></li>
              <li><a href="#" onClick={(e) => this.appendMP(e)}><FontIcon.MdPool/>能力证明</a></li>
              <li><a href="#" onClick={(e) => this.appendSkills(e)}><FontIcon.MdList/>技能清单</a></li>
              <li><a href="#" onClick={(e) => this.appendThanks(e)}><FontIcon.MdSpa/>致谢</a></li>
            </ul>
          </div>
          <div className="WorkingBox">
            <div id="MdEditor"></div>
          </div>
        </div>
        <Modal isOpen={this.state.modalIsOpen}
          contentLabel="捐赠冷熊简历"
          style={{
            content : {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              marginRight           : '-50%',
              transform             : 'translate(-50%, -50%)',
              maxWidth              : '400px',
              minHeight             : '400px'
            },
            overlay: {
              zIndex: '9'
            }
          }}
          >
        <div className="Coffee">
          <h2>给作者投食</h2>
          <p>
            如果冷熊简历在求职过程中帮到了你，可以给作者投喂一个饭团🍙，这样他才有动力来持续改善这个小工具哈。
          </p>
          <img src="https://ws1.sinaimg.cn/large/40dfde6fgy1flpi2zgmi9j20b406odh0.jpg" />
          <p className="CoffeeClose">
            <a href="http://link.ftqq.com/zaImT" target="_blank" rel="noopener noreferrer" >作者微博 @Easy</a> · 
            <a href="#" onClick={(e) => this.closeModal(e)}>关闭窗口</a>
          </p>

        </div>
      </Modal>

      <Modal isOpen={this.state.firstRun}
          contentLabel="冷熊简历使用说明"
          style={{
            content : {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              marginRight           : '-50%',
              transform             : 'translate(-50%, -50%)',
              maxWidth              : '400px'
            },
            overlay: {
              zIndex: '9'
            }
          }}
          >
        <div className="Coffee">
          <h2>使用说明</h2>
          <p>
          欢迎使用冷熊 Markdown 简历工具，您的简历将被自动保存且仅会保存在您的浏览器里，换电脑后将不可见，所以写完后请记得点「下载」保存「MD文件」到电脑；更多功能，请看<a href="https://weibo.com/tv/v/Fw6fNfSkA" target="_blank" rel="noopener noreferrer">教学视频</a>。
          </p>
          <p className="CoffeeClose"> 
            <a href="#" onClick={(e) => this.closeGuide(e)}>关闭</a>
          </p>

          
          {/* <div className="IconDetail">Logo icon made by <a href="http://www.freepik.com" title="Freepik"  target="_blank" rel="noopener noreferrer">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"  target="_blank" rel="noopener noreferrer">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank"  rel="noopener noreferrer">CC 3.0 BY</a></div> */}
          
        </div>
      </Modal>
       
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js